module.exports = "/_next/static/images/PaySuccess-8bd8e46f6deff93e1ccd0c932e1fb5ed.svg";